import React from "react";
import {Button} from "@mui/material";
import CachedIcon from '@mui/icons-material/Cached';
import {CallbackHandler, makeLxTranslations, useLxTranslations} from "@lxo-blocks/react";

interface RetryButtonProps {
    sendNewPush: CallbackHandler
    disabled: boolean,
    countdown: number

}

const MFA_PUSH_RETRY_BTN_TRANSLATION = makeLxTranslations({
    namespace: "mfaPushRetryBtnTranslations",
    translations: {
        BTN_DESCRIPTION: "Erneut senden",
    }
})

export default function RetryButton(props: RetryButtonProps) {
    const {t} = useLxTranslations(MFA_PUSH_RETRY_BTN_TRANSLATION);

    return (
        <>
            <Button color="secondary" onClick={() => props.sendNewPush()} disabled={props.disabled}>
                {t("BTN_DESCRIPTION")}{props.disabled && (" (" + props.countdown + ")")}<CachedIcon
            sx={{pl: 1}}/></Button>
        </>
    );
}